import OLMap from "./index";

export default OLMap;
